import * as React from 'react';
import { useSelector } from 'react-redux';

import { IMainScreenProps, MainScreenDesktop } from '../../components/MainScreen';
import { IApplicationState } from '../../types/redux';

export const MainScreenDesktopContainer: React.FC<React.PropsWithChildren<IMainScreenProps>> = props => {
  const withSaleRentIntro = useSelector((state: IApplicationState) => state.intro.fromSaleRent);

  return <MainScreenDesktop {...props} withSaleRentIntro={withSaleRentIntro} />;
};

MainScreenDesktopContainer.displayName = 'MainScreenDesktopContainer';
